import {
  keyArgsForPaginationWithFilters,
  mergeForPaginationWithFilters,
} from "./modules/utils";

const TranscriptBulkUploadTransactionTypePolicy = {
  TranscriptBulkUploadTransaction: {
    fields: {
      uploadSummary: {
        keyArgs: args => {
          if (args) {
            const keys = keyArgsForPaginationWithFilters(args);
            return keys;
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPaginationWithFilters({
              existing,
              incoming,
              readField,
              fieldVariables: args,
            });
          }
          return incoming;
        },
      },
    },
  },
};

export default TranscriptBulkUploadTransactionTypePolicy;
